'use strict';

import BaseService from './base.service';

class RegistriesService extends BaseService {
    /* @ngInject */
    constructor(Registry, SegaUser) {
        super(Registry, SegaUser);
        Object.assign(this, {
            Registry
        });
    }
}

export default RegistriesService;
